import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { DbService } from "app/services/db/dbService";
import {numberFormatter} from "app/utils/stringUtil";
import moment from "moment";
import DashboardLoading from "app/pages/db/modules/DashboardLoading";
import useInterval from "app/hooks/use-interval";
import { PcAdminService } from "app/services/pc/pcAdminService";

interface total {
  pwrUse: number;
  pwrGenPv: number;
  reSelfSuffRt: number;
  crbnEmit: number;
}

export default function DbRe100Goal() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<total>({pwrUse: 0, crbnEmit: 0, pwrGenPv: 0, reSelfSuffRt: 0});

  useEffect(() => {
    fetch();
  }, []);

  useInterval(() => {
    fetch();
  }, 600000);

  function fetch() {
    const param = { searchIndsCmplxClCd: '', searchType: 'year', fromDt: moment().format('YYYY') };

    Promise.all([
      PcAdminService.getInstance().getEngUseStatus(param),
      DbService.getInstance().getEnrgYearCarbon(),
    ])
    .then(([responseEng, responseGas]) => {
      if(responseEng && responseGas){
        const pwrUseTotal = responseEng?.data?.reduce((acc: any, current: any) => acc + current.pwrUseKepco, 0)
        const pwrGenPvTotal = responseEng?.data?.reduce((acc: any, current: any) => acc + current.pwrGenPv, 0)
        const crbnEmit = responseGas?.data?.strtYyQnt ?? 0
        setTotal({
          pwrUse: pwrUseTotal / 1000,
          crbnEmit: crbnEmit,
          pwrGenPv: pwrGenPvTotal / 1000,
          reSelfSuffRt: (pwrGenPvTotal/pwrUseTotal) * 100,
        });
      }
    })
    .catch(() => {
      setTotal({ pwrUse: 0, crbnEmit: 0, pwrGenPv: 0, reSelfSuffRt: 0 });
    })
    .finally(() => {
      setIsLoading(false);
    });
  }

  return (
    <div className="cont contFlex">
      <DashboardLoading isLoading={isLoading} />
      <div className="graph-list-slider-wrap">
        <div className="graph-list-slider" id="graphListSlider">
          <div className="slider-wrap">
            <ul className="a-slide-item">
              <li>
                <div className="col1">
                  <p className="tit1">산단 에너지 자립률</p>
                  <span className="txt2">최근 업데이트 {dayjs().format('YYYY.MM.DD')}</span>
                  <div className="slide-graph">
                    <div className="graph-count-vertical count-vertical dash">
                      <em data-count={numberFormatter(total.reSelfSuffRt,2)}
                          className="finish"
                          style={{ width: `${total.reSelfSuffRt >= 100 ? 100 : total.reSelfSuffRt}%`}}
                      ></em>
                    </div>
                    <strong><em>{numberFormatter(total.reSelfSuffRt,2)}</em>%</strong>
                  </div>
                </div>
              </li>
              <li>
                <div className="col2">
                  <p className="tit2">연간 한전전력 사용량</p>
                  <p className="txt"><strong>{numberFormatter(total.pwrUse,2)}</strong>MWh</p>
                </div>
              </li>
              <li>
                <div className="col2">
                  <p className="tit2">연간 신재생 발전량</p>
                  <p className="txt"><strong>{numberFormatter(total.pwrGenPv,2)}</strong>MWh</p>
                </div>
              </li>
              <li>
                <div className="col2">
                  <p className="tit2">연간 온실가스 배출량</p>
                  <p className="txt"><strong>{numberFormatter(total.crbnEmit,2)}</strong>tCO₂eq</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}